<template>
	<div class="animated fadeIn">
		<p class="h4">{{ $t('Fields Structures') }}</p>
		<table class="table table-bordered table-striped table-sm">
			<thead>
				<tr>
					<td>{{ $t('Field Name') }}</td>
					<td>{{ $t('Field Type') }}</td>
					<td class="text-center">{{ $t('Action') }}</td>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(field, index) in fieldsSchema" :key="'field_' + index">
					<td>{{ field.name }}</td>
					<td>{{ field.type }}</td>
					<td class="text-center">
						<template v-if="canEdit(field)">
							<button
								:class="btnClass(field) +' mr-2'"
								@click="editFieldMode(index)"
								type="button"
								:title="$t('edit')"
							>
								<i class="fa fa-edit fa-lg"></i>
							</button>
							<button
								:class="btnClass(field)"
								@click="removeField(index)"
								type="button"
								:title="$t('delete')"
							>
								<i class="fa fa-remove fa-lg"></i>
							</button>
						</template>
						<template v-else>-</template>
					</td>
				</tr>
				<tr v-if="!fieldsSchema.length" v-cloak>
					<td colspan="3">
						<div class="text-center">{{ $t('no data') }}!</div>
					</td>
				</tr>
			</tbody>
		</table>
		<tooltip label="field name" placement="right">
			<input
				name="field_name"
				:placeholder="$t('field name')"
				v-validate.disable="'required'"
				:class="{'form-control': true, 'is-invalid': errors.has('field_name')}"
				v-model.trim="field.name"
			/>
			<span v-if="errors.has('field_name')" class="text-danger">{{ $t(errors.first('field_name')) }}</span>
		</tooltip>

		<tooltip label="field Type" placement="right">
			<select
				v-model="field.type"
				name="field_type"
				v-validate="'required'"
				:class="{'form-control': true, 'is-invalid': errors.has('field_type')}"
			>
				<template v-for="(field, i) in fieldsTyps">
					<option
						v-if="!field.hidden"
						:value="field.value"
						:disabled="!!field.disabled"
						:key="'field_' + i"
					>{{ $t(field.name) }}</option>
				</template>
			</select>
			<span v-if="errors.has('field_type')" class="text-danger">{{ $t(errors.first('field_type')) }}</span>
		</tooltip>
		<button type="button" @click="editField(field_mode)" class="btn btn-primary">{{ $t(field_mode) }}</button>
	</div>
</template>
<script>
	export default {
		name: 'field-structures',
		props: ['schema'],
		data() {
			return {
				active_field_index: -1,
				field_mode: 'add',
				field: {
					name: '',
					type: 'text',
					permission: 'rw',
				},
				fieldsSchema: this.schema,
				fieldsTyps: [
					{
						name: 'keyword Type',
						value: 0,
						disabled: 1,
					},
					{
						name: 'Text',
						value: 'text',
					},
					{
						name: 'Number',
						value: 'number',
					},
					{
						name: 'List',
						value: 'list',
						hidden: 1,
					},
					{
						name: 'Location',
						value: 'location',
					},
				],
			}
		},

		methods: {
			btnClass(field) {
				return 'btn btn-link p-0 m-0' + (!this.canEdit(field) ? ' text-muted' : '')
			},

			canEdit(field) {
				return !field.hasOwnProperty('permission') || field.permission === 'rw'
			},

			editField(mode) {
				const newField = {name: '', type: 'text'}

				this.$validator.validateAll(['field_name', 'field_type']).then((status) => {
					if (status === true) {
						if (mode == 'add') {
							if (this.field.name != '' && this.field.type != '0') {
								if (this.checkExistFieldName(this.field.name)) {
									this.$root.notify({
										message: `${this.field.name} field is exist`,
										status: 'info',
										area: 'topRight',
										timeLeft: 0,
									})
								} else {
									this.fieldsSchema.push(this.field)
									this.field = newField
								}
							}
						} else {
							if (this.active_field_index >= 0 && this.field.name != '' && this.field.type.length >= 1) {
								let oldField = this.fieldsSchema[this.active_field_index]
								for (var i = 0; i < this.schema.length; i++) {
									if (i == this.active_field_index) {
										this.fieldsSchema[i] = this.field
									}
								}
								this.$emit('fieldChanged', {
									newField: this.field,
									oldField,
								})
								this.active_field_index = -1
								this.field_mode = 'add'
								this.field = newField
							}
						}

						this.$emit('change', this.fieldsSchema)
					}
				})
			},

			editFieldMode(index) {
				if (this.fieldsSchema[index] && this.canEdit(this.fieldsSchema[index])) {
					this.field_mode = 'edit'
					this.active_field_index = index
					this.field.name = this.fieldsSchema[index].name
					this.field.type = this.fieldsSchema[index].type
				}
			},

			checkExistFieldName(name) {
				for (var i = 0; i < this.fieldsSchema.length; i++) {
					if (this.fieldsSchema[i].name == name) {
						return true
					}
				}
				return false
			},

			removeField(index) {
				if (this.fieldsSchema[index] && this.canEdit(this.fieldsSchema[index])) {
					this.fieldsSchema.splice(index, 1)
					this.$emit('change', this.fieldsSchema)
				}
			},
		},

		watch: {
			schema(newVal) {
				this.fieldsSchema = newVal
			},
		},
	}
</script>
